const moduleMap = {
	"./shareCenterFederatedComponent": () => {
		return Promise.all([__webpack_require__.e(5434), __webpack_require__.e(9141), __webpack_require__.e(3568), __webpack_require__.e(896), __webpack_require__.e(2339), __webpack_require__.e(9610), __webpack_require__.e(9111), __webpack_require__.e(4785), __webpack_require__.e(6088), __webpack_require__.e(6351)]).then(() => (() => ((__webpack_require__(6147)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});